import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@mui/material";
import React from "react";
import { IConfirmationDialog } from "../../interfaces";

export const DeleteValueDialog: React.FC<IConfirmationDialog> = ({
    message,
    open,
    handleClose,
    ...props
}: IConfirmationDialog) => {

    return <Dialog
        open={open}
        onClose={handleClose}
    >
        <DialogTitle>{message ?? "Are you sure?"}</DialogTitle>
        <DialogContent>
            <DialogContentText>This value will not be available when adding or updating materials if you remove it. Existing materials with this value selected will not be affected.</DialogContentText>
        </DialogContent>

        <DialogActions>
            <Button color="primary" onClick={() => handleClose(false)}>Cancel</Button>
            <Button color="error" onClick={() => handleClose(true)}>Remove</Button>
        </DialogActions>
    </Dialog>
}